import { render, staticRenderFns } from "./OngoingFlows.vue?vue&type=template&id=0883bada&scoped=true"
import script from "./OngoingFlows.vue?vue&type=script&lang=js"
export * from "./OngoingFlows.vue?vue&type=script&lang=js"
import style0 from "./OngoingFlows.vue?vue&type=style&index=0&id=0883bada&prod&lang=sass&scoped=true"
import style1 from "./OngoingFlows.vue?vue&type=style&index=1&id=0883bada&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883bada",
  null
  
)

export default component.exports